<template>
  <main class="bg-white py-10">
    <div class="container mx-auto px-4 pb-10">
      <!-- Title -->
      <h2 class="text-center text-3xl mb-8 font-bold text-yellow mt-8">
        Our Professional Team
      </h2>

      <!-- Top Manager (ARC. Dr. Barka Mshelia) -->
      <div class="flex justify-center mb-10">
        <div class="w-72 text-center cursor-pointer group" @click="openModal(ceo)">
          <div class="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300">
            <img class="w-full h-96 object-cover" src="../assets/images/barkaimagee.png" alt="Barka Umaru Mshelia" />
          </div>
          <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">
            Barka Umaru Mshelia
            <!-- <span class="text-xs">FIMC, CPM, CMC</span> -->
          </h4>
          <p class="text-gray-600">GMD/CEO</p>
          <p class="text-yellow text-sm mt-2 hover:underline">View Profile</p>
        </div>
      </div>

      <!-- Executive Team Section -->
      <div class="overflow-x-auto overflow-y-hidden py-6 scroll-wrapper">
        <div class="flex gap-6 px-4 min-w-max">
          <div class="w-72 text-center flex-shrink-0 cursor-pointer group" v-for="member in team" :key="member.name"
            @click="openModal(member)">
            <div class="bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-all duration-300">
              <img class="w-full h-96 object-cover object-top" :src="member.image" :alt="member.name" />
            </div>
            <h4 class="mt-4 text-lg font-semibold text-gray-800 board-style">
              {{ member.name }}
              <span v-if="member.title" class="text-xs">{{
                member.title
              }}</span>
            </h4>
            <p class="text-gray-600">{{ member.position }}</p>
            <p class="text-yellow text-sm mt-4 mb-10 hover:underline">
              View Profile
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <transition name="modal">
      <div v-if="showModal" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-60"
        @click.self="closeModal">
        <div class="bg-white rounded-2xl shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto md:overflow-hidden"
          v-if="selectedMember">
          <div class="flex flex-col md:flex-row">
            <div class="md:w-2/5 bg-gray-100 flex-shrink-0">
              <img :src="selectedMember.image" :alt="selectedMember.name" class="w-full h-64 md:h-full object-cover" />
            </div>

            <div class="md:w-3/5 p-8 md:p-12 md:overflow-y-auto md:max-h-[90vh] relative">
              <button @click="closeModal"
                class="absolute top-6 right-6 w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-600 hover:text-gray-900 transition-all duration-200">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>

              <div class="mb-8 pr-12">
                <div class="inline-block mb-3">
                  <span
                    class="px-3 py-1 bg-amber-500 text-white text-xs font-semibold rounded uppercase tracking-wider">
                    {{ selectedMember.position }}
                  </span>
                </div>
                <h3 class="text-2xl md:text-3xl font-bold text-gray-900 mb-2 leading-tight">
                  {{ selectedMember.name }}
                </h3>
                <span v-if="selectedMember.title" class="text-base text-gray-500 font-medium">{{ selectedMember.title
                  }}</span>
              </div>

              <div class="space-y-4">
                <div class="h-1 w-16 bg-amber-500 rounded-full"></div>
                <p class="text-gray-600 leading-relaxed text-xs md:text-lg text-justify">
                  {{ selectedMember.description }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </main>
</template>

<script>
export default {
  data() {
    return {
      showModal: false,
      selectedMember: null,
      ceo: {
        name: "Barka Umaru Mshelia",
        position: "GMD/CEO",
        image: require("../assets/images/barkaimagee.png"),
        description:
          "Barka Umaru Mshelia is a highly accomplished professional in architecture, entrepreneurship, and project management, with a Bachelor degree in Architecture from MAUTECH. As the GMD Mshel Group Limited, he has become an authority in the construction and real estate industry, with a reputation for delivering quality projects within budget and on time. He excels as a project manager and has a unique ability to manage complex construction projects to the highest standards of quality. Arc. Dr. Barka Umaru Mshelia is also a devout Christian and philanthropist, actively involved in various initiatives through Mshel Foundation to support and empower underprivileged individuals and communities. His passion for excellence and deep rooted faith inspire and motivate many people.",
      },
      team: [
        {
          name: "Anthony Abodunrin Oni",
          title: "FCIHRM",
          position: "Deputy COO",
          image: require("../assets/images/coo-anthony.jpeg"),
          description:
            "Anthony Abodunrin Oni is a business and organizational performance professional with over 13 years of professional experience supporting operational excellence, institutional strengthening, and sustainable growth across diverse business environments. As Deputy Group Chief Operating Officer (COO) at Mshel Group, he works with Group leadership and subsidiary teams to strengthen operational structures, align organizational systems, and support the effective execution of the Group’s strategic priorities across its portfolio of businesses. Anthony combines strategic thinking with practical execution, with expertise in organizational design, performance optimization, and business transformation. He is passionate about building efficient systems, strengthening leadership capability, and enabling the Group to scale sustainably and deliver long-term value.",
        },
        {
          name: "Oluwaseyi Akinsulie",
          title: "Esq",
          position: "Company Secretary",
          image: require("../assets/images/seyi.jpeg"),
          description:
            "Oluwaseyi Olusegun Akinsulie is a seasoned legal practitioner and corporate governance professional with over 13 years of experience in litigation before various superior courts of record, legal advisory, company secretarial practice, and real estate transactions. He serves as the Company Secretary of Mshel Group Limited and its subsidiaries, where he oversees corporate governance, statutory compliance, data protection and board committee administration. Oluwaseyi is a member of the Nigerian Bar Association and a certified mediator, recognised for his professionalism, sound judgment, and practical, business-focused approach to legal and governance matters.",
        },

        {
          name: "Gloria Alugo Egboh",
          title: "CNA",
          position: "Chief Audit Executive",
          image: require("../assets/images/chiefaudit.png"),
          description:
"Gloria Alugo Egboh is a seasoned finance, audit, and governance professional with 20 years of experience across audit, financial management, compliance, tax, risk management, and strategic advisory roles in multinational and indigenous organizations. She is the Chief Audit Executive (CAE) of Mshel Group. In this role she leads the Group’s internal audit function and sets its strategic direction across all subsidiaries. She oversees the development and execution of the Group-wide risk-based audit plan and gives independent, objective assurance on the effectiveness of governance, risk management, and internal control systems. Reporting functionally to the Board Audit Committee, Gloria advises the Board and executive management on emerging risks, control improvements, and governance best practice. Her work strengthens accountability, improves operational efficiency, and safeguards organizational value. Before her appointment as CAE, she served as the Group’s Head of Internal Audit, where she built the foundation for a structured, risk-focused audit function across the Group’s diverse portfolio. Gloria has held senior leadership roles across audit, finance, operations, and compliance. Her experience spans construction, real estate, hospitality, financial services, trade finance, and professional services. She holds a Bachelor’s Degree in Accounting and a Postgraduate Professional Diploma in Accounting. She is a Certified National Accountant (CNA) and a licensed practitioner of the Association of National Accountants of Nigeria (ANAN), with advanced training in forensic accounting, corporate governance, and strategic leadership."        },
        {
          name: "Ameh Atah Meshach",
          position: "Chief Risk Officer",
          image: require("../assets/images/chief-risk-officer.jpeg"),
          description:
            "Ameh Attah serves as the Group Chief Risk Officer (GCRO), overseeing the Company's Enterprise Risk Management (ERM) framework and the identification, assessment, monitoring, and mitigation of strategic, operational, financial, and regulatory risks. With over 12 years of experience in audit, compliance, governance, and financial services, he works closely with the Board of Directors and executive management to strengthen risk culture, enhance organizational resilience, and support the achievement of the Company's strategic objectives.",
        },
        {
          name: "Praise Ojochide Samuel",
          title: "ACA",
          position: "Head of Finance",
          image: require("../assets/images/Praise.jpeg"),
          description:
            "Praise Samuel is a results-driven Chartered Accountant with over 5 years of experience in financial leadership, spanning consultancy and real estate sectors. Proven track record as Head of Group Finance, driving financial strategy, and optimizing business performance. She specializes in Financial Planning, Reporting & Compliance, Budgeting, Risk Management, and Team Leadership. Known for her analytical skills, integrity, and collaborative approach to achieving organizational goals.",
        },

        {
          name: "Alexander Jayeola Kayode",
          title: "ACA",
          position: "Chief Finance Officer",
          image: require("../assets/images/chief-finance2.jpg"),
          description:
            "Alexander Jaiyeola is a strategic financial leader with 12 years of experience driving financial operations, corporate strategy, and risk management across real estate, consultancy, and diverse commercial sectors. Proven track record as Group Chief Financial Officer, specializing in Financial Planning & Analysis (FP&A), treasury management, IFRS reporting, and financial system optimization. He excels in establishing robust internal controls, overhauling reporting frameworks to enhance efficiency, and leading cross-functional teams to achieve sustainable organizational growth. Known for his strong analytical acumen, integrity, and collaborative execution in aligning financial strategies with overarching business objectives.",
        },

        {
          name: "Angela Adigo Kelechukwu",
          title: "",
          position: "Chief Human Resource Officer",
          image: require("../assets/images/mrs-angela.png"),
          description:
          "Angela Adigo Kelechukwu is a trained Architect, Operations Leader, and Business Strategist with a strong footprint in real estate development, organisational growth, and strategic human resource management. She holds both a B.Tech and M.Tech in Architecture from the Federal University of Technology, Akure, graduating with distinction and earning multiple academic excellence awards. As Assistant General Manager, Growth & Strategy at Mshel Homes Limited, she drives strategic planning, operational excellence, and performance optimisation across multiple branches, ensuring sustainable expansion and long-term value creation. Angela combines technical precision with executive leadership, delivering measurable results in cost optimisation, team development, and sustainable housing delivery. A researcher and certified HR practitioner, she remains committed to advancing affordable housing and community-focused urban development across Nigeria.",
        },

        {
          name: "Miracle Ndubaku",
          title: "",
          position: "Chief QHSE Officer",
          image: require("../assets/images/group-risk copy.jpeg"),
          description:
            "Ndubuaku Miracle is a QHSE professional with experience across construction, mining, marine operations, and consultancy environments, specialising in developing and implementing quality, health, safety, and environmental frameworks, risk management, compliance, and continual improvement. He brings a strong track record translating ISO 9001, ISO 45001, and ISO 14001 requirements into practical operational controls. As Chief QHSE Officer at Mshel Group, he provides strategic oversight of the Group's QHSE framework, supporting consistent standards, regulatory compliance, operational risk management, and performance improvement across its diverse businesses. Prior to his current role, he served as Group Quality Manager and HSE Lead at Mshel Construction, where he led the development of the company's HSE management system from the ground up across project sites and prepared it for ISO 45001:2018 certification. His earlier career includes ISO 9001:2015 lead auditor and analyst work for major groups, marine and industrial safety consultancy, and project work developing HSEQ compliance and incident analytics tools. With expertise in ISO management systems, Lean Six Sigma, and risk analysis, Miracle combines practical QHSE leadership with data-driven performance management to improve accountability, informed decision-making, and a culture of quality, safety, environmental responsibility, and continual improvement.",
        },

      ],
    };
  },
  methods: {
    openModal(member) {
      this.selectedMember = member;
      this.showModal = true;
      document.body.style.overflow = "hidden";
    },
    closeModal() {
      this.showModal = false;
      this.selectedMember = null;
      document.body.style.overflow = "";
    },
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
};
</script>

<style scoped>
.board-style {
  font-family: Caveat;
}

.text-yellow {
  color: #f59e0b;
}

.bg-yellow {
  background-color: #f59e0b;
}

.scroll-wrapper {
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
}

.scroll-wrapper::-webkit-scrollbar {
  height: 6px;
}

.scroll-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.scroll-wrapper::-webkit-scrollbar-thumb {
  background: #f59e0b;
  border-radius: 10px;
}

.snap-item {
  scroll-snap-align: start;
}

.modal-enter-active,
.modal-leave-active {
  transition: all 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
  transform: scale(0.95);
}
</style>
